export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7183.19a84810.jpg";